import React from 'react';
import { FormattedMessage } from 'react-intl';

import { ReactFCV } from '@types';

import { useDiscountMessage } from '../hooks';

import { b } from './componentHelpers';
import { IDiscountBody } from './model';
import { StyledDiscountMessage } from './styled';

export const DiscountBody: ReactFCV<IDiscountBody> = ({ percentValue, discountListName, discountType, isDisabled }) => {
  const discountMessage = useDiscountMessage(discountType);

  return (
    <StyledDiscountMessage data-testid="discount-body" isDisabled={isDisabled}>
      <FormattedMessage
        {...discountMessage}
        values={{
          b,
          percent: percentValue,
          listName: discountListName,
        }}
      />
    </StyledDiscountMessage>
  );
};
